import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Text } from '@chakra-ui/react';
import { ROOM_TYPE, FT_PI_BB_CCUI_ROOMS_DISCLAIMER } from '@whitbread-eos/api';
import { Section, Tabs, Button, Notification, Info } from '@whitbread-eos/atoms';
import { useFeatureToggle, renderSanitizedHtml, useSemanticTypography } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useEffect, useState } from 'react';
import { HotelRoomContent } from '../HotelRoomContent';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export default function HotelRoomsComponent(_ref) {
  var isLoading = _ref.isLoading,
    isError = _ref.isError,
    data = _ref.data,
    error = _ref.error,
    isPremierInn = _ref.isPremierInn,
    isLessThanSm = _ref.isLessThanSm,
    isLessThanMd = _ref.isLessThanMd,
    isLessThanLg = _ref.isLessThanLg,
    hotelInventoryResponse = _ref.hotelInventoryResponse,
    roomTypeInformationResponse = _ref.roomTypeInformationResponse,
    isDisplayRates = _ref.isDisplayRates,
    brand = _ref.brand;
  var _useTranslation = useTranslation(['common']),
    t = _useTranslation.t;
  var _useFeatureToggle = useFeatureToggle(),
    isRoomsDisclaimerEnabled = _useFeatureToggle[FT_PI_BB_CCUI_ROOMS_DISCLAIMER];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHydrated = _useState2[0],
    setIsHydrated = _useState2[1];
  useEffect(() => {
    setIsHydrated(true);
  }, []);
  var getTypographyProps = useSemanticTypography();
  var headingLegacyTypography = {
    fontWeight: 'semibold',
    fontSize: {
      base: '2xl',
      md: '3xl'
    },
    lineHeight: '4'
  };
  var headingSemanticTypography = {
    textStyle: 'heading-m'
  };
  var disclaimerLegacyTypography = {
    fontSize: 'sm'
  };
  var disclaimerSemanticTypography = {
    textStyle: 'body-s-regular'
  };
  var tabsStyles = () => ({
    '.chakra-tabs__tablist': {
      w: {
        xl: "calc(100% / 2 - 1.5rem + 1.5rem / 2)",
        lg: "calc(100% / 2 - 1.5rem + 1.5rem / 2)",
        md: '39.813rem',
        mobile: 'full'
      },
      borderBottom: 'none'
    },
    '.chakra-tabs__tab': {
      w: 'full',
      maxWidth: {
        sm: '15rem',
        xs: '8.4rem',
        mobile: '4.65rem'
      },
      borderBottom: '2px solid var(--chakra-colors-lightGrey2)',
      _selected: {
        fontWeight: 'semibold',
        borderBottom: '2px solid var(--chakra-colors-primary)'
      }
    },
    '.chakra-tabs__tab h4': {
      maxWidth: {
        sm: '10rem',
        xs: '5.5rem',
        mobile: '4.65rem'
      },
      textOverflow: {
        xs: 'inherit',
        mobile: 'ellipsis'
      },
      whiteSpace: {
        xs: 'normal',
        mobile: 'nowrap'
      },
      overflow: {
        xs: 'inherit',
        mobile: 'hidden'
      },
      fontSize: {
        sm: '1rem',
        mobile: '.9375rem'
      }
    }
  });
  return _jsx(Section, {
    dataTestId: "hdp_ourRooms",
    children: _jsxs(Box, {
      pb: "4",
      pt: "3xl",
      id: "hotel-details-our-rooms",
      children: [_jsx(Text, _objectSpread(_objectSpread({
        as: "h3",
        "data-testid": "hdp_ourRooms-title"
      }, getTypographyProps(headingLegacyTypography, headingSemanticTypography)), {}, {
        children: t('hoteldetails.roomtypes.title')
      })), renderTabs(), renderSeeRatesButton(isDisplayRates), isRoomsDisclaimerEnabled && renderRoomsDisclaimer(brand)]
    })
  });
  function renderTabs() {
    var _data$tabGroups;
    if (isLoading) {
      return _jsx(Text, {
        children: t('searchresults.list.hotel.loading')
      });
    }
    if (isError) {
      return _jsx(Text, {
        children: error.message
      });
    }
    if (!data) {
      return null;
    }
    if (hotelInventoryResponse) {
      if (hotelInventoryResponse !== null && hotelInventoryResponse !== void 0 && hotelInventoryResponse.isLoadingHotelInventory) {
        return _jsx(Text, {
          "data-testid": "hotel-inventory-loading-message",
          children: t('searchresults.list.hotel.loading')
        });
      }
      if (hotelInventoryResponse !== null && hotelInventoryResponse !== void 0 && hotelInventoryResponse.isErrorHotelInventory) {
        return _jsx(Text, {
          children: hotelInventoryResponse.errorHotelInventory.message
        });
      }
    }
    if (roomTypeInformationResponse) {
      if (roomTypeInformationResponse !== null && roomTypeInformationResponse !== void 0 && roomTypeInformationResponse.isLoadingRoomTypeInformation) {
        return _jsx(Text, {
          "data-testid": "room-types-loading-message",
          children: t('searchresults.list.hotel.loading')
        });
      }
      if (roomTypeInformationResponse !== null && roomTypeInformationResponse !== void 0 && roomTypeInformationResponse.isErrorRoomTypeInformation) {
        return _jsx(Text, {
          children: roomTypeInformationResponse.errorRoomTypeInformation.message
        });
      }
    }
    return _jsx(Tabs, {
      mt: 6,
      pt: 4,
      showRoomInventory: !isPremierInn,
      prefixDataTestId: "roomConfiguration",
      sx: _objectSpread({}, tabsStyles()),
      labelStyles: {
        selected: {
          textStyle: 'body-m-emphasis'
        },
        unselected: {
          textStyle: 'body-m-regular'
        }
      },
      styles: {
        tab: {
          w: 'full',
          maxWidth: {
            sm: '15rem',
            xs: '8.4rem',
            mobile: 'unset'
          },
          borderBottom: '2px solid var(--chakra-colors-lightGrey2)',
          pr: {
            md: '0',
            mobile: '1.5rem'
          },
          pl: {
            md: '0',
            mobile: '1.5rem'
          },
          mb: 0,
          _selected: {
            fontWeight: 'semibold',
            borderBottom: '2px solid var(--chakra-colors-primary)'
          }
        },
        tabList: {
          w: {
            xl: "calc(98% / 2 - 1.5rem + 1.5rem / 2)",
            lg: "calc(98% / 2 - 1.5rem + 1.5rem / 2)",
            md: '38.813rem',
            mobile: 'unset'
          },
          borderBottom: 'none',
          ml: {
            md: 0,
            mobile: '-1rem'
          },
          mr: {
            md: 0,
            mobile: '-1rem'
          },
          pl: {
            md: 0,
            mobile: '1rem'
          },
          pr: {
            md: 0,
            mobile: '1rem'
          },
          overflow: {
            mobile: 'auto'
          }
        }
      },
      options: data === null || data === void 0 || (_data$tabGroups = data.tabGroups) === null || _data$tabGroups === void 0 ? void 0 : _data$tabGroups.filter(tabGroup => {
        var _data$tabItems;
        return data === null || data === void 0 || (_data$tabItems = data.tabItems) === null || _data$tabItems === void 0 ? void 0 : _data$tabItems.some(tabItem => (tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomType) === (tabGroup === null || tabGroup === void 0 ? void 0 : tabGroup.groupId));
      }).map((tabGroup, index) => {
        var _tabGroup$groupName, _data$tabItems2, _tabGroup$groupId, _tabGroup$groupId2;
        return _objectSpread({
          index,
          label: (_tabGroup$groupName = tabGroup === null || tabGroup === void 0 ? void 0 : tabGroup.groupName) !== null && _tabGroup$groupName !== void 0 ? _tabGroup$groupName : '',
          content: _jsx(HotelRoomContent, {
            tabItems: data === null || data === void 0 || (_data$tabItems2 = data.tabItems) === null || _data$tabItems2 === void 0 ? void 0 : _data$tabItems2.filter(tabItem => (tabItem === null || tabItem === void 0 ? void 0 : tabItem.roomType) === (tabGroup === null || tabGroup === void 0 ? void 0 : tabGroup.groupId)),
            isLessThanSm,
            isLessThanMd,
            isLessThanLg
          })
        }, !isPremierInn && {
          roomTypeInventoryCount: getTotalInventoryAvailCountPerTabRoomType((_tabGroup$groupId = tabGroup === null || tabGroup === void 0 ? void 0 : tabGroup.groupId) !== null && _tabGroup$groupId !== void 0 ? _tabGroup$groupId : ''),
          roomTypeInventoryRoomTypesWithCount: getInventoryRoomTypeLabelsWithCount((_tabGroup$groupId2 = tabGroup === null || tabGroup === void 0 ? void 0 : tabGroup.groupId) !== null && _tabGroup$groupId2 !== void 0 ? _tabGroup$groupId2 : '')
        });
      })
    });
  }
  function renderSeeRatesButton(isDisplayRates) {
    var seeRatesBtnStyles = {
      mt: 'sm',
      fontSize: 'md',
      height: 'var(--chakra-space-xl)',
      width: {
        mobile: 'full',
        sm: '48',
        lg: '40',
        xl: '12%'
      }
    };
    var handleClickScroll = () => {
      var rateCardElement = document.querySelector('[data-testid="hdp_rateCard"]');
      if (rateCardElement) {
        rateCardElement.scrollIntoView({
          behavior: 'smooth'
        });
      }
    };
    if (isPremierInn) {
      return _jsx(Button, _objectSpread(_objectSpread({
        variant: "secondary",
        size: "md",
        "data-testid": "hdp_roomsSeeRates"
      }, seeRatesBtnStyles), {}, {
        style: {
          display: isHydrated && isDisplayRates ? 'block' : 'none'
        },
        onClick: handleClickScroll,
        children: t('hoteldetails.roomtypes.rates.button')
      }));
    }
  }
  function renderRoomsDisclaimer(brand) {
    var description = renderSanitizedHtml(t("hotelInfo.disclaimer.".concat(brand)));
    var disclaimerProps = getTypographyProps(disclaimerLegacyTypography, disclaimerSemanticTypography);
    var descriptionTextStyle = 'textStyle' in disclaimerProps ? disclaimerProps.textStyle : undefined;
    var descriptionStrongTextStyle = descriptionTextStyle ? 'body-s-emphasis' : undefined;
    return _jsx(Box, {
      mt: "md",
      mb: "lg",
      children: _jsx(Notification, {
        status: "info",
        variant: "infoGrey",
        svg: _jsx(Info, {}),
        description: _jsx(_Fragment, {
          children: description
        }),
        prefixDataTestId: "hdp_rooms_disclaimer",
        descriptionTextStyle: descriptionTextStyle,
        descriptionStrongTextStyle: descriptionStrongTextStyle
      })
    });
  }
  function mapRoomTypeInfoToHotelInvViaRoomTypeCode(tabGroupId) {
    var _roomTypeInformationR;
    if (!(roomTypeInformationResponse !== null && roomTypeInformationResponse !== void 0 && roomTypeInformationResponse.dataRoomTypeInformation) || !(hotelInventoryResponse !== null && hotelInventoryResponse !== void 0 && hotelInventoryResponse.dataHotelInventory)) {
      return null;
    }
    var matchedRoomTypeCodes = roomTypeInformationResponse === null || roomTypeInformationResponse === void 0 || (_roomTypeInformationR = roomTypeInformationResponse.dataRoomTypeInformation) === null || _roomTypeInformationR === void 0 || (_roomTypeInformationR = _roomTypeInformationR.roomTypeInformation) === null || _roomTypeInformationR === void 0 ? void 0 : _roomTypeInformationR.roomTypes.filter(item => {
      var _hotelInventoryRespon;
      return hotelInventoryResponse === null || hotelInventoryResponse === void 0 || (_hotelInventoryRespon = hotelInventoryResponse.dataHotelInventory) === null || _hotelInventoryRespon === void 0 || (_hotelInventoryRespon = _hotelInventoryRespon.hotelInventory) === null || _hotelInventoryRespon === void 0 ? void 0 : _hotelInventoryRespon.roomTypeInventories.find(_ref2 => {
        var code = _ref2.code;
        return item.roomTypeCode === code || item.roomTypeCode.includes(code);
      });
    });
    var matchedRoomTypeGroupIdToTabsGroupId = matchedRoomTypeCodes === null || matchedRoomTypeCodes === void 0 ? void 0 : matchedRoomTypeCodes.filter(item => matchRoomTypeGroupIdToTabsGroupId(tabGroupId, item.roomTypeCode, item === null || item === void 0 ? void 0 : item.groupId));
    return matchedRoomTypeGroupIdToTabsGroupId;
  }
  function matchRoomTypeGroupIdToTabsGroupId(tabGroupId, roomTypeCode, roomTypeGroupId) {
    var _roomTypeGroupId;
    var doubleRoomClassRoomCodes = [ROOM_TYPE.STANDARD, ROOM_TYPE.STANDARD_BIGGER, ROOM_TYPE.STANDARD_EXTRA, ROOM_TYPE.PREMIER_PLUS];
    if ((doubleRoomClassRoomCodes.indexOf(String(roomTypeCode)) !== -1 || doubleRoomClassRoomCodes.some(el => roomTypeCode.indexOf(el) !== -1)) && roomTypeGroupId !== 'double') {
      roomTypeGroupId = 'double';
    }
    return (_roomTypeGroupId = roomTypeGroupId) === null || _roomTypeGroupId === void 0 ? void 0 : _roomTypeGroupId.toLowerCase().includes(tabGroupId.toLowerCase());
  }
  function getInventoryRoomTypeLabelsWithCount(tabGroupId) {
    var mappedRoomTypeDataPerTab = mapRoomTypeInfoToHotelInvViaRoomTypeCode(tabGroupId);
    var isFamilyRoom = tabGroupId.toLowerCase() === 'family' || tabGroupId.toLowerCase() === 'familie';
    if (!mappedRoomTypeDataPerTab) return null;
    if (isFamilyRoom) {
      var inventoryRoomTypeLabels = mappedRoomTypeDataPerTab.map(item => {
        var label = '';
        if (item.roomTypeCode === ROOM_TYPE.FAMILY_QUAD || item.roomTypeCode.includes(ROOM_TYPE.FAMILY_QUAD)) {
          label = t('hoteldetails.roomtypes.quad');
        }
        if (item.roomTypeCode === ROOM_TYPE.FAMILY_TRIPLE || item.roomTypeCode.includes(ROOM_TYPE.FAMILY_TRIPLE)) {
          label = t('hoteldetails.roomtypes.triple');
        }
        return label;
      });
      var inventoryAvailCountsPerRoomType = getInventoryAvailCountPerRoomType(tabGroupId);
      if (!inventoryAvailCountsPerRoomType) return null;
      var inventoryRoomTypeLabelsWithCount = inventoryRoomTypeLabels.map(function (item, i) {
        return item + " (".concat(inventoryAvailCountsPerRoomType[i], ") ");
      }).join('').toString();
      return inventoryRoomTypeLabelsWithCount;
    } else {
      var _inventoryRoomTypeLabelsWithCount = '';
      return _inventoryRoomTypeLabelsWithCount;
    }
  }
  function getInventoryAvailCountPerRoomType(tabGroupId) {
    var _hotelInventoryRespon2;
    if (!hotelInventoryResponse) return null;
    var mappedRoomTypeDataPerTab = mapRoomTypeInfoToHotelInvViaRoomTypeCode(tabGroupId);
    if (!mappedRoomTypeDataPerTab) return null;
    return hotelInventoryResponse === null || hotelInventoryResponse === void 0 || (_hotelInventoryRespon2 = hotelInventoryResponse.dataHotelInventory) === null || _hotelInventoryRespon2 === void 0 || (_hotelInventoryRespon2 = _hotelInventoryRespon2.hotelInventory) === null || _hotelInventoryRespon2 === void 0 ? void 0 : _hotelInventoryRespon2.roomTypeInventories.filter(item => mappedRoomTypeDataPerTab.find(_ref3 => {
      var roomTypeCode = _ref3.roomTypeCode;
      return item.code === roomTypeCode || roomTypeCode.includes(item.code);
    })).map(roomTypeMatch => roomTypeMatch.availableCount);
  }
  function getTotalInventoryAvailCountPerTabRoomType(tabGroupId) {
    var inventoryAvailCountsPerRoomType = getInventoryAvailCountPerRoomType(tabGroupId);
    if (!inventoryAvailCountsPerRoomType) return null;
    var totalInventoryAvailCountPerRoomType = inventoryAvailCountsPerRoomType.reduce((a, b) => a + b, 0) || 0;
    return totalInventoryAvailCountPerRoomType;
  }
}